export default {
    "zh-CN": {
        countries: {
            AL: "阿尔巴尼亚",
            DZ: "阿尔及利亚",
            AF: "阿富汗",
            AR: "阿根廷",
            EH: "阿拉伯撒哈拉民主共和国",
            AE: "阿联酋",
            AW: "阿鲁巴",
            OM: "阿曼",
            AZ: "阿塞拜疆",
            IE: "爱尔兰",
            EG: "埃及",
            ET: "埃塞俄比亚",
            EE: "爱沙尼亚",
            AD: "安道尔",
            AO: "安哥拉",
            AI: "安圭拉",
            AG: "安提瓜和巴布达",
            AU: "澳大利亚",
            AT: "奥地利",
            AX: "奥兰",
            BB: "巴巴多斯",
            PG: "巴布亚新几内亚",
            BS: "巴哈马",
            PK: "巴基斯坦",
            PY: "巴拉圭",
            PS: "巴勒斯坦",
            BH: "巴林",
            PA: "巴拿马",
            BR: "巴西",
            BY: "白俄罗斯",
            BM: "百慕大",
            BG: "保加利亚",
            MP: "北马里亚纳群岛",
            MK: "北马其顿",
            BJ: "贝宁",
            BE: "比利时",
            PE: "秘鲁",
            IS: "冰岛",
            BW: "博茨瓦纳",
            PR: "波多黎各",
            BA: "波黑",
            PL: "波兰",
            BO: "玻利维亚",
            BZ: "伯利兹",
            BT: "不丹",
            BF: "布基纳法索",
            BI: "布隆迪",
            BV: "布韦岛",
            KP: "朝鲜",
            GQ: "赤道几内亚",
            DK: "丹麦",
            DE: "德国",
            TL: "东帝汶",
            TG: "多哥",
            DO: "多米尼加",
            DM: "多米尼克",
            EC: "厄瓜多尔",
            ER: "厄立特里亚",
            RU: "俄罗斯",
            FR: "法国",
            FO: "法罗群岛",
            PF: "法属波利尼西亚",
            GF: "法属圭亚那",
            TF: "法属南部领地",
            MF: "法属圣马丁",
            VA: "梵蒂冈",
            FJ: "斐济",
            PH: "菲律宾",
            FI: "芬兰",
            CV: "佛得角",
            FK: "福克兰群岛",
            GM: "冈比亚",
            CG: "刚果（布）",
            CD: "刚果（金）",
            GD: "格林纳达",
            GL: "格陵兰",
            GE: "格鲁吉亚",
            CO: "哥伦比亚",
            CR: "哥斯达黎加",
            GG: "根西",
            CU: "古巴",
            GP: "瓜德罗普",
            GU: "关岛",
            GY: "圭亚那",
            KZ: "哈萨克斯坦",
            HT: "海地",
            KR: "韩国",
            HM: "赫德岛和麦克唐纳群岛",
            NL: "荷兰",
            BQ: "荷兰加勒比区",
            SX: "荷属圣马丁",
            ME: "黑山",
            HN: "洪都拉斯",
            DJ: "吉布提",
            KG: "吉尔吉斯斯坦",
            KI: "基里巴斯",
            GN: "几内亚",
            GW: "几内亚比绍",
            GH: "加纳",
            CA: "加拿大",
            GA: "加蓬",
            KH: "柬埔寨",
            CZ: "捷克",
            ZW: "津巴布韦",
            CM: "喀麦隆",
            QA: "卡塔尔",
            KY: "开曼群岛",
            CC: "科科斯（基林）群岛",
            HR: "克罗地亚",
            KM: "科摩罗",
            XK: "科索沃",
            CI: "科特迪瓦",
            KW: "科威特",
            KE: "肯尼亚",
            CK: "库克群岛",
            CW: "库拉索",
            LV: "拉脱维亚",
            LS: "莱索托",
            LA: "老挝",
            LB: "黎巴嫩",
            LR: "利比里亚",
            LY: "利比亚",
            LT: "立陶宛",
            LI: "列支敦士登",
            RE: "留尼汪",
            LU: "卢森堡",
            RW: "卢旺达",
            RO: "罗马尼亚",
            MG: "马达加斯加",
            IM: "马恩岛",
            MV: "马尔代夫",
            MT: "马耳他",
            MW: "马拉维",
            MY: "马来西亚",
            ML: "马里",
            MH: "马绍尔群岛",
            MQ: "马提尼克",
            YT: "马约特",
            MU: "毛里求斯",
            MR: "毛里塔尼亚",
            US: "美国",
            UM: "美国本土外小岛屿",
            AS: "美属萨摩亚",
            VI: "美属维尔京群岛",
            MN: "蒙古",
            BD: "孟加拉国",
            MS: "蒙特塞拉特",
            FM: "密克罗尼西亚联邦",
            MM: "缅甸",
            MD: "摩尔多瓦",
            MA: "摩洛哥",
            MC: "摩纳哥",
            MZ: "莫桑比克",
            MX: "墨西哥",
            NA: "纳米比亚",
            ZA: "南非",
            AQ: "南极洲",
            GS: "南乔治亚和南桑威奇群岛",
            SS: "南苏丹",
            NR: "瑙鲁",
            NI: "尼加拉瓜",
            NP: "尼泊尔",
            NE: "尼日尔",
            NG: "尼日利亚",
            NU: "纽埃",
            NF: "诺福克岛",
            NO: "挪威",
            PW: "帕劳",
            PN: "皮特凯恩群岛",
            PT: "葡萄牙",
            JP: "日本",
            SE: "瑞典",
            CH: "瑞士",
            SV: "萨尔瓦多",
            WS: "萨摩亚",
            RS: "塞尔维亚",
            SL: "塞拉利昂",
            SN: "塞内加尔",
            CY: "塞浦路斯",
            SC: "塞舌尔",
            SA: "沙特阿拉伯",
            BL: "圣巴泰勒米",
            CX: "圣诞岛",
            ST: "圣多美和普林西比",
            SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
            KN: "圣基茨和尼维斯",
            LC: "圣卢西亚",
            SM: "圣马力诺",
            PM: "圣皮埃尔和密克隆",
            VC: "圣文森特和格林纳丁斯",
            LK: "斯里兰卡",
            SK: "斯洛伐克",
            SI: "斯洛文尼亚",
            SJ: "斯瓦尔巴和扬马延",
            SZ: "斯威士兰",
            SD: "苏丹",
            SR: "苏里南",
            SB: "所罗门群岛",
            SO: "索马里",
            TJ: "塔吉克斯坦",
            TH: "泰国",
            TZ: "坦桑尼亚",
            TO: "汤加",
            TC: "特克斯和凯科斯群岛",
            TT: "特立尼达和多巴哥",
            TR: "土耳其",
            TM: "土库曼斯坦",
            TN: "突尼斯",
            TV: "图瓦卢",
            TK: "托克劳",
            WF: "瓦利斯和富图纳",
            VU: "瓦努阿图",
            GT: "危地马拉",
            VE: "委内瑞拉",
            BN: "文莱",
            UG: "乌干达",
            UA: "乌克兰",
            UY: "乌拉圭",
            UZ: "乌兹别克斯坦",
            ES: "西班牙",
            GR: "希腊",
            SG: "新加坡",
            NC: "新喀里多尼亚",
            NZ: "新西兰",
            HU: "匈牙利",
            SY: "叙利亚",
            JM: "牙买加",
            AM: "亚美尼亚",
            YE: "也门",
            IT: "意大利",
            IQ: "伊拉克",
            IR: "伊朗",
            IL: "以色列",
            IN: "印度",
            ID: "印尼",
            GB: "英国",
            VG: "英属维尔京群岛",
            IO: "英属印度洋领地",
            JO: "约旦",
            VN: "越南",
            ZM: "赞比亚",
            JE: "泽西",
            TD: "乍得",
            GI: "直布罗陀",
            CL: "智利",
            CF: "中非",
            CN: "中国",
            MO: "中国澳门",
            TW: "中国台湾",
            HK: "中国香港"
        }
    }
};
